<ng-container [appPreloader]="[endpoints.CHART_ACCOUNTS_GET, endpoints.CHART_ACCOUNTS_POST, endpoints.CHART_ACCOUNTS_PUT, endpoints.CHART_ACCOUNTS_DELETE]"
  [preloaderType]="preloaderTypes.OVERLAY"
  [preloaderSize]="20">
</ng-container>

<div class="row">
  <div class="col-md-6">
    @if (isLoaded) {
      @if (chartAccountsList.length) {
        <div>
          <div>
            <div class="fs-big fw-bolder c-secondary mb-5">Custom {{ categoryLabel }} Categories List</div>
            <mat-nav-list class="chart-accounts-list">
              @for (chartAccounts of chartAccountsList.items; track $index) {
                <mat-list-item class="chart-accounts"
                  [class.selected]="chartAccounts.id === selectedChartAccounts?.id"
                  (click)="toggle(chartAccounts)">
                  <a matLine>{{ chartAccounts.name }}</a>
                  <!--<i class="icon icon-edit mr-5"></i>-->
                  <i class="icon icon-trash"
                    appStopPropagation
                    [appConfirm]="messages.CONFIRM_DELETE"
                    (accepted)="delete(chartAccounts)">
                  </i>
                </mat-list-item>
              }
            </mat-nav-list>
          </div>
        </div>
      } @else {
        <div class="no-data">
          <div>
            <div class="fs-big fw-bolder c-secondary mb-5">Custom {{ categoryLabel }} Categories List</div>
            <div class="fs-default c-text">Custom categories will appear in the dropdown to select when allocating</div>
          </div>
        </div>
      }
    } @else {
      <p-skeleton width="150px" height="16px" styleClass="mb-15"></p-skeleton>

      <div class="align-h-space-between mb-15">
        <div>
          <p-skeleton width="120px" height="16px" styleClass="mb-10"></p-skeleton>
          <p-skeleton width="60px" height="16px" styleClass="mb-10"></p-skeleton>
          <p-skeleton width="80px" height="16px" styleClass="mb-10"></p-skeleton>
        </div>
        <div class="f-column align-v-bottom">
          <p-skeleton shape="circle" size="16px" styleClass="mb-10"></p-skeleton>
          <p-skeleton shape="circle" size="16px" styleClass="mb-10"></p-skeleton>
          <p-skeleton shape="circle" size="16px" styleClass="mb-10"></p-skeleton>
          <div></div>
        </div>
      </div>
    }
  </div>

  <div class="col-md-6">
    <form [formGroup]="form" (ngSubmit)="submit()" class="p-10">
      <div class="fs-big fw-bolder c-secondary">Add Custom {{ categoryLabel }} Categories</div>
      <div class="fs-small mb-15">Custom categories can be edited but not deleted if transactions have been allocated.</div>

      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" required>
        <mat-error>
          <app-validation-error [errors]="form.get('name').errors"></app-validation-error>
        </mat-error>
      </mat-form-field>

      @if (!category) {
        <mat-radio-group formControlName="category" class="default" color="primary">
          <mat-radio-button [value]="chartAccountsCategories.PERSONAL_EXPENSE" class="mr-10">Expense</mat-radio-button>
          <mat-radio-button [value]="chartAccountsCategories.PERSONAL_INCOME">Income</mat-radio-button>
        </mat-radio-group>
      }

      @if (category) {
        <ng-container formArrayName="depreciations">
          @for (depreciationGroup of form.depreciationsArray.controls; track depreciationGroup) {
            <div>
              <mat-form-field [formGroup]="depreciationGroup">
                <mat-label>Effective Life</mat-label>
                <input matInput type="number" formControlName="effectiveLife" required>
                <mat-error>
                  <app-validation-error [errors]="depreciationGroup.get('effectiveLife').errors"></app-validation-error>
                </mat-error>
              </mat-form-field>
            </div>
          }
        </ng-container>
      }

      <div class="mt-15">
        <button class="btn primary">Save</button>
        <button type="button" [class.d-none]="!selectedChartAccounts" (click)="reset()" class="btn basic">Cancel</button>
      </div>
    </form>
  </div>
</div>
